export type ScrollAreaViewport = React.RefObject<HTMLDivElement | null>;

export const scrollToBottom = (viewport: ScrollAreaViewport) =>
    viewport.current && viewport.current.scrollTo({ top: viewport.current.scrollHeight, behavior: "smooth" });

export const isScrollVisible = (viewport: ScrollAreaViewport) => {
    if (!viewport.current) return false;

    const { scrollHeight, clientHeight } = viewport.current;
    if (scrollHeight === undefined || clientHeight === undefined) return false;

    return scrollHeight !== clientHeight;
};
